import AboutContent from "./sections/AboutContent/AboutContent";
import AboutHero from "./sections/AboutHero/AboutHero";

const AboutUS = () => {
  return (
    <div>
      <AboutHero />
      <AboutContent />
    </div>
  );
};

export default AboutUS;
